import { Privacy } from "../../Components/Privacy/Privacy";

function PrivacyPage() {
    return <Privacy />;
}

export default PrivacyPage;
